import React, {useEffect, useRef, useState} from 'react';
import {GET_COLLECTION_AGGREGATE_DATA, SEARCH_COLLECTION_URL} from '../../api';
import "jquery";
import DataTable from "datatables.net-dt";
import 'select2';
import $ from 'jquery';
import cogoToast from "cogo-toast";
import {useSelector} from "react-redux";
import {capitalize} from "../../utils/capitalize";
import moment from "moment";
import Modal from "bootstrap/js/dist/modal";
import "select2/dist/css/select2.min.css";
import {user} from "../../api/app";
const _$ = window.$;

let searchableFields = [
    { field: 'name', isNumeric: false },
    { field: 'mobile_number', isNumeric: true }
]

const Influencer = () => {

    document.title = "Influencer";

    const auth = useSelector((state) => state.auth.user);
    const token = localStorage.getItem('jwtToken');
    const [stateReady, setStateReady] = useState(false);
    const searchQueryRef = useRef('');
    const searchTimeout = useRef(null);
    const [editForm, setEditForm] = useState(false);
    const [editId, setEditId] = useState(0);

    const handleSearch = (e) => {
        const value = e.target.value;
        clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            searchQueryRef.current = value;
            reloadTable();
        }, 800);
    };

    useEffect(() => {
        let table = new DataTable('#admin', {
            responsive: true,
            dom: 'tip',
            language: {
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Client Data</p>'
            },
            searching: false,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function (data, callback) {
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: searchQueryRef.current,
                        collection: "user",
                        searchableFields,
                        filter: {
                            admin: auth.user.role === 'admin' ? {} : `ObjectId(${auth.user.sub})`
                        },
                        populate: [
                            {
                                path: 'admin',
                                model: 'admin',
                            }
                        ],
                        pageSize: data.start,
                        format: 'json',
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        res.data.map((data) => {
                            array.push({raw: data})
                        });

                        $("#total-influencer").text(res?.total ? res.total : 0)

                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                { "className": "align-middle", "targets": "_all" },
                {
                    "render": function (data) {
                        return `<div class="d-flex align-items-center">
                            <img style="margin-right: 12px" src="assets/img/profile.png" height="48" alt="profile"/>
                            <span class="text-default">${capitalize(data.name)}</span>
                        </div>`;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return data.mobile_number
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return moment(data.date.iso).format("Do MMM, YYYY")
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return `<div class="dropdown">
                                    <a href="javascript:void(0)" class="nav-link text-center" data-bs-toggle="dropdown">
                                    <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1C2.26522 1 2.51957 1.10536 2.70711 1.29289C2.89464 1.48043 3 1.73478 3 2C3 2.26522 2.89464 2.51957 2.70711 2.70711C2.51957 2.89464 2.26522 3 2 3C1.73478 3 1.48043 2.89464 1.29289 2.70711C1.10536 2.51957 1 2.26522 1 2C1 1.73478 1.10536 1.48043 1.29289 1.29289Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1.29289 8.29289C1.48043 8.10536 1.73478 8 2 8C2.26522 8 2.51957 8.10536 2.70711 8.29289C2.89464 8.48043 3 8.73478 3 9C3 9.26522 2.89464 9.51957 2.70711 9.70711C2.51957 9.89464 2.26522 10 2 10C1.73478 10 1.48043 9.89464 1.29289 9.70711C1.10536 9.51957 1 9.26522 1 9C1 8.73478 1.10536 8.48043 1.29289 8.29289Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1.29289 15.2929C1.48043 15.1054 1.73478 15 2 15C2.26522 15 2.51957 15.1054 2.70711 15.2929C2.89464 15.4804 3 15.7348 3 16C3 16.2652 2.89464 16.5196 2.70711 16.7071C2.51957 16.8946 2.26522 17 2 17C1.73478 17 1.48043 16.8946 1.29289 16.7071C1.10536 16.5196 0.999999 16.2652 0.999999 16C0.999999 15.7348 1.10536 15.4804 1.29289 15.2929Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    </a>
                                      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a class="dropdown-item text-secondary" href="#/influencer/${data._id}"><i class="fa fa-user"></i> View Profile</a></li>
                                        <li><hr class="dropdown-divider"></li>
                                        <li><a class="dropdown-item text-secondary edit_user" href="#"><i class="fa fa-pencil"></i> Edit User</a></li>
                                        <li><hr class="dropdown-divider"></li>
                                        <li><a class="dropdown-item text-danger delete_user" href="#"><i class="fa fa-trash"></i> Delete User</a></li>
                                      </ul>
                                </div>`
                    },
                    "targets": 3
                }
            ]
        });

        table.on('click', '.delete_user', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this user, ${extract_td.raw.name}?`);
            $('#delete-data').unbind("click").click(function(){

                const modal = Modal.getInstance(document.getElementById("modalConfirm"));
                modal.hide();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                user("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("User successfully removed.", {position: "top-right"});
                    }
                });
            });

            const modal = Modal.getOrCreateInstance($('#modalConfirm')[0], {backdrop: 'static', focus: false});
            modal.show();
        });

        table.on('click', '.edit_user', function(e) {
            e.preventDefault();

            let name = $("#name");
            let mobile_number = $("#mobile");
            let team_select2 = $("#team-select2");
            let extract_td = table.row($(this).closest('tr')).data();

            setEditForm(true);
            setEditId(extract_td.raw._id);

            name.prop('disabled', true);
            team_select2.prop('disabled', true);

            $("#password").prop('required', false);
            initialize();

            name.val(extract_td.raw.name);
            mobile_number.val(extract_td.raw.mobile_number);

            team_select2.prop("disabled", true).prop("required", false);

            let $_option = $("<option selected></option>").val(extract_td.raw.admin._id).text(capitalize(extract_td.raw.admin.name));
            team_select2.append($_option).trigger('change');

            const modalElement = $('#modalInfluencer')[0];
            modalElement.addEventListener('shown.bs.modal', function handleShown() {
                $('#influencer_form').parsley();
                modalElement.removeEventListener('shown.bs.modal', handleShown);
            });

            const modal = Modal.getOrCreateInstance(modalElement);
            modal.show();
        });

        return () => {
            table.destroy();
        }
    }, []);

    const handleShowModal = () => {
        _$('#influencer_form').parsley();
        setEditForm(false);
        initialize();

        let name = $("#name");
        let email = $("#email");
        let team_select2 = $("#team-select2");

        name.prop('disabled', false);
        email.prop('disabled', false);
        team_select2.prop('disabled', false);
        $("#password").prop('required', true);

        const modal = Modal.getOrCreateInstance($('#modalInfluencer')[0], {backdrop: 'static', focus: false});
        modal.show();
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let name = $('#name').val();
        let mobile_number = $('#mobile').val();
        let team = auth.user.role === "admin" ? $('#team-select2').val()[0] : auth.user.sub;
        let password = $('#password').val();

        setStateReady(true);

        if(editForm) {
            let data = {
                id: editId,
                name,
                mobile_number,
                password
            };

            user("put", data).then((result) => {
                setStateReady(false);

                if(!result.error) {
                    cogoToast.success("Influencer successfully updated.", {position: "top-right", hideAfter: 5});
                    resetForm("modalInfluencer", "influencer_form");
                    reloadTable();
                }
            });

            return false;
        }

        let data = {
            name,
            mobile_number,
            team,
            password
        };

        user("post", data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success("Influencer successfully created.", {position: "top-right", hideAfter: 5});
                resetForm("modalInfluencer", "influencer_form");
                reloadTable();
            }
        });
    }

    const initialize = () => {
        let modalProduct = $('#modalInfluencer');
        $('#team-select2').select2({
            placeholder: 'Select team/influencer',
            allowClear: true,
            maximumSelectionLength: 1,
            width:"100%",
            dropdownParent: modalProduct,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token
                },
                data: function(query) {
                    return {
                        query: query,
                        collection: "admin"
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });
    }

    const resetForm = (id, form) => {
        const parsley = _$(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        const modal = Modal.getInstance(document.getElementById(id));
        modal.hide();
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const reloadTable = () => {
        new DataTable('#admin').ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="d-flex justify-content-between">
                <div>
                    <h2>Influencer</h2>
                    <h5>Monitoring your global digital presence across all platforms.</h5>
                </div>
                <div>
                    <a href="javascript:void(0)" className="btn btn-primary btn-create" onClick={handleShowModal.bind()}>
                        <svg className="me-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.75 0C4.374 0 0 4.374 0 9.75C0 15.126 4.374 19.5 9.75 19.5C15.126 19.5 19.5 15.126 19.5 9.75C19.5 4.374 15.126 0 9.75 0ZM9.75 1.5C14.3153 1.5 18 5.18475 18 9.75C18 14.3153 14.3153 18 9.75 18C5.18475 18 1.5 14.3153 1.5 9.75C1.5 5.18475 5.18475 1.5 9.75 1.5ZM9 5.25V9H5.25V10.5H9V14.25H10.5V10.5H14.25V9H10.5V5.25H9Z" fill="#FFFFFF"/>
                        </svg>
                        Create Influencer
                    </a>
                </div>
            </div>

            <div className="card card-view mt-3">
                <div className="p-3 d-flex justify-content-between align-items-end">
                    <div>
                        <h2 style={{fontSize: 64}} id="total-influencer">0</h2>
                        <h5 style={{marginBottom: 0}}>Total influencers</h5>
                    </div>
                    <div className="position-relative" style={{ width: "20%" }}>
                        <svg style={{position: "absolute", left: "12px", top: "54%", transform: "translateY(-50%)", pointerEvents: "none"}} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.7832 14.3911L20 18.6069L18.6069 20L14.3911 15.7832C12.8224 17.0407 10.8713 17.7246 8.86088 17.7218C3.96968 17.7218 0 13.7521 0 8.86088C0 3.96968 3.96968 0 8.86088 0C13.7521 0 17.7218 3.96968 17.7218 8.86088C17.7246 10.8713 17.0407 12.8224 15.7832 14.3911ZM13.8082 13.6605C15.0574 12.3754 15.7552 10.6531 15.7527 8.86088C15.7527 5.05366 12.6681 1.96909 8.86088 1.96909C5.05366 1.96909 1.96909 5.05366 1.96909 8.86088C1.96909 12.6681 5.05366 15.7527 8.86088 15.7527C10.6531 15.7552 12.3754 15.0574 13.6605 13.8082L13.8082 13.6605Z" fill="#9893AE"/>
                        </svg>
                        <input type="text" className="form-control" placeholder="Search influencer..." style={{ paddingLeft: "40px" }} onChange={handleSearch}/>
                    </div>
                </div>
                <div className="card-body table-responsive p-0">
                    <table id="admin" className="table">
                        <thead>
                        <tr>
                            <th className="wd-25p">Name</th>
                            <th className="wd-25p">Mobile Number</th>
                            <th className="wd-25p">Date</th>
                            <th className="wd-25p">Action</th>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>

            <div className="modal fade" id="modalInfluencer" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                            <h5 className="modal-title">{editForm ? "Edit Influencer" : "Create Influencer"}</h5>
                            <a href="javascript:void(0)" role="button" data-dismiss="modal" aria-label="Close" onClick={resetForm.bind(null, "modalInfluencer", "influencer_form")}>
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="32" height="32" rx="16" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5272 12.5287C12.6522 12.4037 12.8218 12.3335 12.9986 12.3335C13.1753 12.3335 13.3449 12.4037 13.4699 12.5287L15.9986 15.0573L18.5272 12.5287C18.5887 12.465 18.6623 12.4142 18.7436 12.3793C18.825 12.3443 18.9124 12.3259 19.001 12.3252C19.0895 12.3244 19.1773 12.3413 19.2592 12.3748C19.3411 12.4083 19.4156 12.4578 19.4782 12.5204C19.5407 12.583 19.5902 12.6574 19.6238 12.7394C19.6573 12.8213 19.6742 12.9091 19.6734 12.9976C19.6726 13.0861 19.6542 13.1736 19.6193 13.2549C19.5843 13.3363 19.5336 13.4098 19.4699 13.4713L16.9412 16L19.4699 18.5287C19.5913 18.6544 19.6585 18.8228 19.657 18.9976C19.6555 19.1724 19.5854 19.3396 19.4618 19.4632C19.3382 19.5868 19.171 19.6569 18.9962 19.6585C18.8214 19.66 18.653 19.5928 18.5272 19.4713L15.9986 16.9427L13.4699 19.4713C13.3442 19.5928 13.1758 19.66 13.001 19.6585C12.8262 19.6569 12.6589 19.5868 12.5353 19.4632C12.4117 19.3396 12.3416 19.1724 12.3401 18.9976C12.3386 18.8228 12.4058 18.6544 12.5272 18.5287L15.0559 16L12.5272 13.4713C12.4022 13.3463 12.332 13.1768 12.332 13C12.332 12.8232 12.4022 12.6537 12.5272 12.5287Z" fill="white"/>
                                </svg>
                            </a>
                        </div>
                        <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                            <form id="influencer_form" className="parsley-style-1" onSubmit={handleSubmit.bind()}>
                                <div id="senderWrapper" className="form-group parsley-input">
                                    <label>Full Name<span className="tx-danger">*</span></label>
                                    <input id="name" type="text" className="form-control"
                                           placeholder="Enter full name"
                                           autoComplete="off"
                                           data-parsley-class-handler="#senderWrapper" required/>
                                </div>

                                <div id="subjectWrapper" className="form-group parsley-input">
                                    <label>Mobile Number<span className="tx-danger">*</span></label>
                                    <input id="mobile" type="text" className="form-control"
                                           placeholder="Enter mobile number"
                                           autoComplete="off"
                                           data-parsley-class-handler="#subjectWrapper" required/>
                                </div>

                                {auth.user.role === "admin" && (
                                    <div id="teamWrapper" className="form-group parsley-input mb-3">
                                        <label className="form-label">Team <span style={{fontSize: 12}}>(Optional)</span></label>
                                        <select className="form-control form-select" id="team-select2" data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#teamWrapper"
                                                data-parsley-errors-container="#teamWrapper"
                                                autoComplete="off"
                                        />
                                    </div>
                                )}

                                <div id="passwordWrapper" className="form-group parsley-input">
                                    <label>One-Time Password<span className="tx-danger">*</span></label>
                                    <input id="password" type="text" className="form-control"
                                           placeholder="Enter 4 digits PIN"
                                           autoComplete="off"
                                           maxLength="4"
                                           pattern="[0-9]{4}"
                                           inputMode="numeric"
                                           data-parsley-class-handler="#passwordWrapper"
                                           required
                                    />
                                </div>

                                <div className="d-grid">
                                    {stateReady ? <button disabled className="btn btn-secondary btn-block"><span className="spinner-border spinner-border-sm" style={{marginRight: 10}} role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-primary btn-block">{editForm ? "Update" : "Create"}</button>}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content tx-14">
                        <div className="modal-body">
                            <h6 className="data-message">Empty</h6>
                            <p className="mg-b-0 data-message-warning">This action cannot be undone</p>
                        </div>
                        <div className="modal-footer">
                            <div className="d-flex gap-2 w-100">
                                <button type="button" className="btn btn-outline-secondary w-50 mt-0" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" id="delete-data" className="btn btn-danger w-50">Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Influencer;
